import {
  IPresignedPost,
  TUploadType,
  buildMediaUrl,
  uploadFileToS3,
} from "MVVM/Utilities/MediaUpload";

export type { IPresignedPost, TUploadType };

export const MAX_BACKGROUND_BYTES = 30 * 1024 * 1024;

const MIME_TO_UPLOAD_TYPE: Record<string, TUploadType> = {
  "image/jpeg": "JPEG",
  "image/png": "PNG",
  "image/gif": "GIF",
};

export const BACKGROUND_ACCEPT_FREE = "image/png,image/jpeg";
export const BACKGROUND_ACCEPT_PAID = "image/png,image/jpeg,image/gif";

export const canUploadGifs = (tier?: string | null): boolean =>
  !!tier && tier !== "FREE";

type TValidationResult =
  | { ok: true; type: TUploadType }
  | { ok: false; message: string };

export const validateBackgroundFile = (
  file: File,
  options: { allowGifs: boolean },
): TValidationResult => {
  const type = MIME_TO_UPLOAD_TYPE[file.type];

  if (!type)
    return { ok: false, message: "Please choose a PNG, JPEG, or GIF image." };

  if (type === "GIF" && !options.allowGifs) {
    return {
      ok: false,
      message: "Animated backgrounds require a paid subscription",
    };
  }

  if (file.size > MAX_BACKGROUND_BYTES)
    return { ok: false, message: "Image must be 30 MB or smaller." };

  return { ok: true, type };
};

export const buildBackgroundUrl = buildMediaUrl;

export const uploadBackgroundToS3 = uploadFileToS3;
